var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCountry5(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 124,
    viewBox: "0 0 131 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_344_505",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 131,
    height: 124
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 130.658,
    height: 124,
    rx: 33,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 129.658,
    height: 123,
    rx: 32.5,
    stroke: "#1E417C",
    strokeOpacity: 0.2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_344_505)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-12.4844 0H153.959V124H-12.4844V0Z",
    fill: "#00247D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.4844 0H70.7371V62H-12.4844V0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.73186 0L28.9963 23.3792L60.5945 0H70.7371V8.00833L39.529 31.1292L70.7371 54.1208V62H60.3344L29.1264 38.8792L-1.95166 62H-12.4844V54.25L18.5936 31.2583L-12.4844 8.26667V0H-2.73186Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6499 36.2958L70.7371 56.8333V62L35.498 36.2958H42.6499ZM18.7237 38.8792L19.5039 43.4L-5.46256 62H-12.4844L18.7237 38.8792ZM70.7371 0V0.3875L38.3587 24.6708L38.6188 18.9875L64.2354 0H70.7371ZM-12.4844 0L18.5936 22.7333H10.7916L-12.4844 5.425V0Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8537 0V62H39.6591V0H18.8537ZM-12.4844 20.6667V41.3333H70.7371V20.6667H-12.4844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.4844 24.9292V37.3292H70.7371V24.9292H-12.4844ZM23.0148 0V62H35.498V0H23.0148Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.423 101.68L117.618 105.658L115.553 99.1226L121.453 94.8601H114.078L111.423 88.6084L109.358 94.8601H101.688L107.588 99.1226L105.523 105.658L111.423 101.68Z",
    fill: "#ED4C5C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.422 101.68L105.522 105.659L107.587 99.1228L101.687 94.8603H109.357L111.422 88.6086L114.077 94.8603H121.452L115.552 99.1228L117.617 105.659L111.422 101.68ZM116.769 99.5217L119.473 108.081L111.436 102.92L103.635 108.18L106.371 99.5217L98.4883 93.8269H108.604L111.3 85.6631L114.767 93.8269H124.651L116.769 99.5217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.424 28.428L115.993 31.5168L114.28 26.4624L118.849 23.3736H113.423L111.424 18.6001L109.996 23.3736H104.285L108.854 26.4624L107.141 31.5168L111.424 28.428Z",
    fill: "#ED4C5C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.427 28.4277L107.143 31.5164L108.857 26.4621L104.288 23.3733H109.999L111.427 18.5998L113.426 23.3733H118.851L114.282 26.4621L115.996 31.5164L111.427 28.4277ZM115.52 26.8753L117.969 34.1006L111.446 29.6906L105.118 34.254L107.619 26.8753L100.91 22.34H109.223L111.263 15.5186L114.12 22.34H122.229L115.52 26.8753Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9939 57.0411L91.5551 60.1916L89.8447 55.0362L94.4059 51.8856H88.7044L86.9939 47.0166L85.2835 51.8856H79.582L84.1432 55.0362L82.4328 60.1916L86.9939 57.0411Z",
    fill: "#ED4C5C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.9918 57.0412L82.4306 60.1918L84.141 55.0363L79.5799 51.8858H85.2813L86.9918 47.0168L88.7022 51.8858H94.4037L89.8425 55.0363L91.5529 60.1918L86.9918 57.0412ZM91.0733 55.4448L93.5156 62.806L86.9918 58.2998L80.4679 62.806L82.9102 55.4448L76.2617 50.8525H84.5425L86.9917 43.8804L89.441 50.8525H97.7218L91.0733 55.4448Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountry5);
export default __webpack_public_path__ + "static/media/country5.5e5c962f037bc0002f9987a5ac351b28.svg";
export { ForwardRef as ReactComponent };